import BaseModel from "./BaseModel";
import ObjectFactory from "./ObjectFactory";
import { AboHandeling } from "../components/Abohandeling";

ObjectFactory.registerClass("ProjectLicense", (data?: any, parent?: BaseModel) => {
  return new ProjectLicense({});
});

export enum ProjectLicenseType {
  EtsExport = "EtsExport", // no itx
  EtsSync = "EtsSync", // no itx
  Documentation = "Documentation", // no itx
  ExcelExport = "ExcelExport", // no itx
  GiraExport = "GiraExport", // no itx
}

export default class ProjectLicense extends BaseModel {
  public get className(): string {
    return "ProjectLicense"; // no itx
  }

  licenses:
    | Array<{
        type: string;
        itemId: string;
        invoiceId: string;
        purchaseDate: string;
      }>
    | undefined;
  // expiryDate    : string = "";

  deviceIds: Array<string> | undefined = undefined;
  private oldAboTypes = ["personal", "pro", "elite", "unlimited"];

  /**
   * Fügt eine Geräte-ID zur Liste der lizenzierten Geräte hinzu.
   * @param deviceId - Die eindeutige ID des Geräts
   */
  addDeviceId(deviceId: string) {
    this.deviceIds = this.deviceIds || [];
    if (!this.deviceIds.includes(deviceId)) {
      this.deviceIds.push(deviceId);
    }
  }

  get deviceCount(): number {
    return this.deviceIds ? this.deviceIds.length : 0;
  }

  /**
   * Berechnet die Gesamtanzahl der lizenzierten Geräte.
   * Berücksichtigt sowohl gekaufte Lizenzen als auch aktive Abonnements (Pro/Elite = 1000 Geräte).
   * @returns Die maximale Anzahl an Geräten, die verwendet werden dürfen
   */
  get licensedDevices(): number {
    let count = 0;

    // first add devices from abo

    count += this.getDefaultDevicesFromAbo();
    if (this.hasDummyAboProjectLicense()) {
      count += 1000;
    }
    // then add purchased licenses
    for (const l of this.licenses || []) {
      const deviceNumberMatch = l.type.match(/\d+/);
      const deviceNumber = deviceNumberMatch ? parseInt(deviceNumberMatch[0]) : 0;

      if (deviceNumber > 0) {
        count += deviceNumber;
      }
    }

    return count;
  }

  private hasDummyAboProjectLicense(): boolean {
    const invoiceIds = state.projectMetadata?.projectLicence?.invoiceIds || [];
    return invoiceIds.some((id) => (id || "").toLowerCase() === "dummyabo");
  }

  getDefaultDevicesFromAbo(): number {
    let count = 0;
    const abo = state.loggedInUser?.abo?.toLowerCase() || "";

    if (!abo.includes("business") && !abo.includes("dummy")) {
      for (let oldAbo of this.oldAboTypes) {
        if (abo.includes(oldAbo)) {
          return 1000;
        }
      }
      return 0;
    }

    if (abo.includes("starter")) {
      count = 60;
    } else if (abo.includes("pro")) {
      count = 100;
    } else if (abo.includes("elite")) {
      count = 1000;
    } else if (abo.includes("unlimited")) {
      count = 1000;
    }
    return count;
  }

  /**
   * Fügt eine neue Lizenz zum Projekt hinzu.
   * Prüft automatisch, ob die Lizenz bereits existiert (anhand der itemId).
   * @param licenseType - Der Typ der Lizenz (z.B. "10-Devices-EUR")
   * @param itemId - Eindeutige ID des Lizenz-Items
   * @param invoiceId - ID der zugehörigen Rechnung
   * @param purchaseDate - Kaufdatum der Lizenz
   */
  addLicense(licenseType: string, itemId: string, invoiceId: string, purchaseDate: string) {
    this.licenses = this.licenses || [];

    if (this.licenses.find((l) => l.itemId === itemId)) {
      return; // license already exists
    }

    this.licenses.push({
      type: licenseType,
      itemId: itemId,
      invoiceId: invoiceId,
      purchaseDate: purchaseDate,
    });
    // Update project metadata for handeling outside of project
    state.projectMetadata?.updateProjectLicence();
  }
  /**
   * Entfernt eine Lizenz vom Projekt.
   * @param licenseType - Der Typ der Lizenz (z.B. "10-Devices-EUR")
   * @param itemId - Eindeutige ID des Lizenz-Items
   */
  removeLicense(itemId: string) {
    this.licenses = this.licenses || [];

    if (this.licenses.find((l) => l.itemId === itemId)) {
      // we remove the license
      this.licenses = this.licenses.filter((l) => l.itemId !== itemId);
    }

    // Update project metadata for handeling outside of project
    state.projectMetadata?.updateProjectLicence();
  }

  /**
   * Prüft und registriert Geräte für die Lizenzierung.
   * Wenn kein Parameter übergeben wird, werden alle Geräte im Projekt geprüft.
   * @param oneDeviceId - Optional: ID eines einzelnen Geräts zum Prüfen
   * @returns Die Anzahl der Geräte, die über dem Lizenzlimit liegen (0 = alles OK, >0 = Limit überschritten)
   */
  checkAndSetDevices(oneDeviceId?: string): number {
    const newToSetDeviceIds = new Array<string>();
    /// check first if devices are allready in list

    if (oneDeviceId) {
      if (this.deviceIds?.includes(oneDeviceId)) {
        return 0;
      }
      newToSetDeviceIds.push(oneDeviceId);
    } else {
      for (let dev of state.allDevices().filter((dev) => dev.template)) {
        if (!this.deviceIds?.includes(dev.id)) {
          newToSetDeviceIds.push(dev.id);
        }
      }
    }
    // we set dem and afterwards check if we are still in limit
    newToSetDeviceIds.forEach((devId) => {
      this.addDeviceId(devId);
    });

    if (this.deviceCount > this.licensedDevices) {
      // not enough place for the new devices

      return this.deviceCount - this.licensedDevices;
    }

    return 0;
  }

  get pl(): string {
    return JSON.stringify(this.licenses);
  }

  set pl(value: string) {
    this.licenses = JSON.parse(value);
  }

  getPersistentProperties(): string[] {
    return super.getPersistentProperties().concat(["pl"]); // no itx
  }

  constructor(data?: any, parent?: BaseModel) {
    super(data, parent);
  }

  /** Subscriptions include PDF and Excel documentation without project licenses or device limits. */
  get hasDocumentationSubscription(): boolean {
    const user = state.loggedInUser;
    const abo = user?.abo?.trim().toLowerCase();
    return (
      !!abo &&
      !abo.includes("dummy") &&
      AboHandeling.aboValid(abo, user?.abo_status, user?.abo_end ? new Date(user.abo_end) : undefined)
    );
  }

  /**
   * Prüft, ob eine bestimmte Funktionalität mit der aktuellen Lizenz verwendet werden darf.
   * Berücksichtigt sowohl Gerätelimits als auch Abonnement-Status.
   * @param licenseType - Der Enum Typ der zu prüfenden Funktionalität (z.B. ProjectLicenseType.EtsExport, GiraExport)
   * @returns true wenn die Funktionalität verwendet werden darf, false wenn Lizenz fehlt oder Limit überschritten
   */
  checkLicenses(licenseType: ProjectLicenseType): boolean {
    if (
      (licenseType === ProjectLicenseType.Documentation || licenseType === ProjectLicenseType.ExcelExport) &&
      this.hasDocumentationSubscription
    ) {
      return true;
    }
    let res = true;
    let notLicensedTypes = this.checkAndSetDevices();
    // first check device limits
    const abo = state.loggedInUser?.abo;
    if (!abo.includes("business") && !abo.includes("dummy")) {
      if (abo.includes(this.oldAboTypes) || abo.includes("unlimited")) {
        return true;
      }
    }
    if (this.hasDummyAboProjectLicense()) {
      return true;
    }
    if (notLicensedTypes > 0) {
      console.log("Not licensed devices for type ", licenseType, " notLicensedTypes:", notLicensedTypes);
      return false;
    }

    switch (licenseType) {
      case ProjectLicenseType.EtsExport:
        if (notLicensedTypes > 0) {
          res = false;
        }
        break;
      case ProjectLicenseType.GiraExport:
        res = false;
        this.licenses?.forEach((lic) => {
          if (lic.type.toLocaleLowerCase().includes("gira")) {
            res = true;
          }
        });
        break;
      case ProjectLicenseType.EtsSync:
        if (notLicensedTypes > 0) {
          res = false;
        }
        break;
      case ProjectLicenseType.ExcelExport:
      case ProjectLicenseType.Documentation:
        let hasDocumentLicense = false;
        this.licenses?.forEach((lic) => {
          if (lic.type.toLocaleLowerCase().includes("document")) {
            hasDocumentLicense = true;
          }
        });
        if (notLicensedTypes > 0 && !hasDocumentLicense) {
          res = false;
        }
        break;
    }

    ////////////////////////////////////////////
    // handle different lycensetypes here has to be first becaus of setting of devices
    let anothDevicesUser = [
      ProjectLicenseType.EtsExport,
      ProjectLicenseType.GiraExport,
      ProjectLicenseType.ExcelExport,
      ProjectLicenseType.EtsSync,
      ProjectLicenseType.Documentation,
    ];
    if (anothDevicesUser.includes(licenseType) && notLicensedTypes > 0) {
      res = false;
    }
    if (abo == "no" && licenseType == ProjectLicenseType.GiraExport) {
    }
    ////////////////////////////////////////////
    //abo afterwards but has more priority
    if (state.loggedInUser?.abo != "no") {
      return true;
    }

    return res;
  }

  checkIfProfessionalAbo(): boolean {
    return state.loggedInUser?.abo != "no" && !state.loggedInUser?.abo.includes("dummy");
  }
}
